import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  input: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0 1rem 0',
    height: '40px',
    paddingBottom: '0.25rem',

    '& input': {
      flex: '1',
      border: 'none',
      outline: 'none',
      fontSize: theme.size.sm
    }
  },

  dropdown: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0',

    '& > :first-child': {
      marginRight: '0.5rem'
    },

    '& .menu': {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${theme.border.outline}`,
      borderRadius: '5px',
      boxSizing: 'border-box',
      padding: '0.25rem',

      '& svg': {
        height: '0.75rem',
        width: '0.75rem'
      },

      '& > :first-child': {
        color: theme.palette.textAlt,
        marginRight: '1rem'
      }
    }
  },

  topPad: {
    marginTop: '1rem'
  },

  hoursBlock: {
    display: 'flex',
    flexDirection: 'column'
  },

  hours: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.textAlt,
    marginBottom: '0.5rem',

    '& > div': {
      marginRight: '0.5rem'
    },

    '& .input': {
      width: '4.5rem'
    },

    '& input': {
      height: 'auto',
      padding: '5px 7px',
      textAlign: 'center'
    },

    '& fieldset': {
      borderTop: 'none',
      borderRight: 'none',
      borderLeft: 'none',
      borderRadius: '0'
    },

    '& .delete': {
      marginLeft: '1.5rem',
      cursor: 'pointer',
      height: '1rem',
      width: '1rem'
    }
  },

  hoursTicks: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.5rem',

    '& > :not(:last-child)': {
      marginRight: '0.5rem'
    }
  },

  hoursTick: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',

    '& .MuiCheckbox-root': {
      marginRight: '0 !important'
    },

    '& > :first-child': {
      justifyContent: 'center'
    },

    '& > :last-child': {
      color: theme.palette.textAlt
    }
  },

  addHours: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    color: 'lightgrey',
    cursor: ({ addHoursDisabled }) =>
      addHoursDisabled ? 'default' : 'pointer',

    '& .button': {
      fontSize: theme.size.base,
      marginRight: '0.5rem',
      height: '1rem',
      width: '1rem'
    }
  },

  warning: {
    color: theme.palette.indicator.red
  },

  divider: {
    margin: '0.75rem 0',
    width: '50%'
  },

  roleSection: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.5rem'
  },

  roleTitle: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.5rem'
  },

  roleList: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',

    '& > div': {
      marginTop: 2,
      marginBottom: 2
    },

    '& > :not(:last-child)': {
      marginRight: '8px'
    }
  },

  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #C6C6C6',
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '4px 8px',
    background: '#F5F6F8',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    cursor: 'default'
  },

  removeRoleIcon: {
    marginLeft: '4px',
    cursor: 'pointer',
    height: 14,
    width: 14
  },

  endControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    marginTop: '10px',

    [theme.breakpoints.down(769)]: {
      '& button': {
        fontSize: theme.size.base
      }
    },

    [theme.breakpoints.down(451)]: {
      justifyContent: 'space-between',
      margin: '1rem 0',
      width: '100%',

      '& button': {
        flexBasis: '48.5%'
      },

      '& > button > .MuiButton-label': {
        fontSize: theme.size.sm
      },

      '& > div': {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginTop: '0.5rem',
        marginLeft: '0',
        marginBottom: '2rem'
      }
    }
  },

  button: {
    marginRight: '0.5rem',
    width: 'auto',
    padding: '0 1rem',
    fontSize: theme.size.sm,

    '&:last-child': {
      marginRight: '0'
    }
  }
}))

export default useStyles
